var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 5.13333H9.63141",
    stroke: "#56B734",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99997 2.56667H10.5233C11.7991 2.56667 12.8333 3.60089 12.8333 4.87667V10.5233C12.8333 11.7991 11.7991 12.8333 10.5233 12.8333H4.87665C3.60087 12.8333 2.56665 11.7991 2.56665 10.5233V7.7",
    stroke: "#56B734",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56665 9.625L5.13332 7.05833C5.72891 6.48522 6.46272 6.48522 7.05832 7.05833L10.2667 10.2667",
    stroke: "#56B734",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98334 8.98334L9.625 8.34167C10.2206 7.76856 10.9544 7.76856 11.55 8.34167L12.8333 9.625",
    stroke: "#56B734",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54 0.5C1.68947 0.5 1 1.18945 1 2.04V5.12C1 5.97055 1.68947 6.66 2.54 6.66H6.39C7.24053 6.66 7.93 5.97055 7.93 5.12V2.04C7.93 1.18945 7.24053 0.5 6.39 0.5H2.54ZM2.925 4.35H6.005C6.21764 4.35 6.39 4.52239 6.39 4.735C6.39 4.94761 6.21764 5.12 6.005 5.12H2.925C2.71236 5.12 2.54 4.94761 2.54 4.735C2.54 4.52239 2.71236 4.35 2.925 4.35ZM2.54 2.425C2.54 2.21239 2.71236 2.04 2.925 2.04H6.005C6.21764 2.04 6.39 2.21239 6.39 2.425C6.39 2.63761 6.21764 2.81 6.005 2.81H2.925C2.71236 2.81 2.54 2.63761 2.54 2.425Z",
    fill: "#56B734"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextImage);
export default __webpack_public_path__ + "static/media/text-image.9be9a658290928ec79020bbfff88b290.svg";
export { ForwardRef as ReactComponent };